module.exports = __webpack_public_path__ + "img/top2.cb80928e.png";